module.exports = __webpack_public_path__ + "static/media/4_r_detal_83.49_94.54.4c407281.png";